/**
 * A tracker's name as people say it, for every line that says where a task comes from ("From Plane", "Mark done in
 * Plane"). Keyed by the `kind` a task's source and a project's sources carry, so the next tool is one line here.
 */
export const TRACKER_NAME = { plane: 'Plane' } as const;
